import { Link } from "react-router-dom";

export function NotFoundContent() {
  return (
    <div className="min-h-screen bg-background-50 flex items-center justify-center px-4 py-24">
      <div className="text-center">
        <p className="font-heading text-6xl md:text-7xl text-primary-500 comic-pop">404</p>
        <h1 className="mt-4 text-xl md:text-2xl font-heading text-foreground-950">页面走丢了</h1>
        <p className="mt-2 text-sm text-foreground-600">你要找的内容不存在或已被移动，回到首页继续逛吧。</p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 font-bold text-sm whitespace-nowrap hover:bg-primary-600 transition-colors"
        >
          <i className="ri-home-5-line"></i> 返回首页
        </Link>
      </div>
    </div>
  );
}

export default function NotFound() {
  return <NotFoundContent />;
}